module.exports = __webpack_public_path__ + "img/saveurs-nutrition.1b717f90.jpg";